export const aboutData = {
  brandIntro: {
    title: '关于蜜桃网站',
    subtitle: '让每一天都充满甜蜜与美好',
    content: [
      '蜜桃网站创立于2020年，是专为年轻用户打造的甜蜜生活内容平台。我们深耕时尚、美食、情感、生活方式等多元领域，致力于用温暖、专业、有趣的内容，陪伴每一位追求美好生活的年轻人。',
      '"蜜桃"这个名字源于我们对生活的理解——生活应该像蜜桃一样，外表粉嫩可爱，内在甜而不腻。我们希望每一位来到蜜桃网站的用户，都能在这里找到属于自己的那份甜蜜。',
      '经过多年的发展，蜜桃网站已经从最初的个人博客成长为拥有超过50万活跃用户的生活方式内容平台。我们的内容团队由来自时尚、美食、心理学、旅行等不同领域的专业创作者组成，每月产出超过200篇优质原创内容。',
    ],
    stats: [
      { label: '活跃用户', value: '50万+' },
      { label: '原创内容', value: '5000+' },
      { label: '合作品牌', value: '200+' },
      { label: '内容创作者', value: '80+' },
    ],
  },
  reputation: {
    title: '品牌口碑',
    content: [
      '蜜桃网站自成立以来，始终坚持"内容为王、用户至上"的核心理念。我们不以流量为唯一导向，而是专注于创作真正对用户有价值的内容。这种坚持，为我们赢得了广泛的用户认可和行业赞誉。',
      '我们的内容多次被人民日报、新华社、央视网等主流媒体转载推荐。在第三方评测机构"新榜"发布的生活方式类内容平台排名中，蜜桃网站连续三年位居前十。',
      '更重要的是，我们收到了无数用户的温暖反馈。有人说，蜜桃网站陪伴她度过了最难熬的失恋期；有人说，我们的美食攻略让他在异乡找到了家的味道；还有人说，我们的穿搭建议帮助她重拾了自信。这些故事，是我们前进的最大动力。',
    ],
    awards: [
      '2023年度中国生活方式类内容平台TOP10',
      '2023年新榜最具影响力内容品牌',
      '2024年度年度最佳原创内容平台',
      '2024年度用户最喜爱的生活方式APP',
    ],
  },
  contact: {
    title: '联系我们',
    description: '无论你是想投稿、寻求合作，还是有任何建议和想法，我们都非常期待听到你的声音。',
    email: 'hello@mitao.readdy.ai',
    address: '北京市朝阳区建国路88号SOHO现代城A座1506',
    phone: '+86 10 8888 6666',
    social: [
      { name: '微信公众号', icon: 'ri-wechat-line', url: '#' },
      { name: '微博', icon: 'ri-weibo-line', url: '#' },
      { name: '小红书', icon: 'ri-red-packet-line', url: '#' },
      { name: '抖音', icon: 'ri-tiktok-line', url: '#' },
      { name: 'B站', icon: 'ri-bilibili-line', url: '#' },
    ],
  },
};